import React from 'react'
import { Link } from 'react-router-dom'

export default class About extends React.Component {
  componentDidMount() {
    document.title = 'About'
  }

  render() {
    return (
      <div>
        <section className="container fadeInUp photo">
          <div className="col-6-of-12">
            <img src={ROOT_DATA_NEW.about.image} />
          </div>
          <div className="col-4-of-12 pull-2">
            <h1>About Me</h1>
            <h2>{ROOT_DATA_NEW.about.profession}</h2>
          </div>
        </section>
        <section className="container fadeInUp profile">
          <div className="col-5-of-12">
            <h4>Profile</h4>
          </div>
          <div className="col-7-of-12 link-border">
            <p>
              {ROOT_DATA_NEW.about.bio}
            </p>
          </div>
        </section>
        <section className="container fadeInUp profile">
          <div className="col-5-of-12">
            <h4>Studies</h4>
          </div>
          <div className="col-7-of-12">
            <ul className="experience">
              {ROOT_DATA_NEW.about.studies.map((study) => {
                return (
                  <li key={study._id}>
                    <h4>
                      <span><a target="_blank" rel="noopener noreferrer" href={study.url}>{study.school_name}</a></span>
                      <span>{study.year}</span>
                    </h4>
                    <span>{study.description}</span>
                  </li>
                )
              })}
              
      
            </ul>
          </div>
        </section>

        <section className="container fadeInUp profile">
          <div className="col-5-of-12">
            <h4>Experience</h4>
          </div>
          <div className="col-7-of-12">
            <ul className="experience">
              {ROOT_DATA_NEW.about.experience.map((exp) => {
                  return (
                    <li key={exp._id}>
                      <h4>
                        <span><a target="_blank" rel="noopener noreferrer" href={exp.url}>{exp.project}</a></span>
                        <span>{exp.year}</span>
                      </h4>
                      <span>{exp.position}</span>
                    </li>
                  )
              })}
            </ul>
          </div>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/javascripts/pages/About.js